import { ReactNode } from 'react';
import { Text, Tooltip } from '@mantine/core';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';
import { CopyIconButton } from '@dealstack/frontend/shared/components/CopyIconButton/CopyIconButton.tsx';
import { InvestorDetailsRowStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestorDetailsRow/InvestorDetailsRow.styles.tsx';

const isTextValue = (value: ReactNode): value is string | number =>
	(typeof value === 'string' && value.length > 0) || typeof value === 'number';

interface Props {
	label: string;
	value?: ReactNode;
	copyValue?: string | null;
	bordered?: boolean;
	size?: 'md' | 'sm';
	padding?: string;
	showValueTooltip?: boolean;
	valueTooltip?: string;
	dataTestId?: string;
	copyDataTestId?: string;
}

export const InvestorDetailsRow = ({
	label,
	value,
	copyValue,
	bordered = false,
	size = 'md',
	padding = '0.5rem',
	showValueTooltip = false,
	valueTooltip,
	dataTestId,
	copyDataTestId,
}: Props) => {
	const fz = size === 'sm' ? 12 : 14;

	return (
		<InvestorDetailsRowStyles
			className={[bordered && 'bordered', size].filter(Boolean).join(' ')}
			$padding={padding}
		>
			<Text className="label" fz={fz} c="dark.0" title={label}>
				{label}
			</Text>

			<div className="value" data-testid={dataTestId}>
				{!!copyValue && (
					<div className="copy">
						<CopyIconButton value={copyValue} dataTestId={copyDataTestId} />
					</div>
				)}

				{isTextValue(value) ? (
					<Tooltip
						label={valueTooltip ?? value}
						disabled={!showValueTooltip && !valueTooltip}
						withArrow
					>
						<Text
							fz={fz}
							fw={600}
							c="dark.8"
							title={showValueTooltip || valueTooltip ? undefined : String(value)}
							className="details-value"
						>
							{value}
						</Text>
					</Tooltip>
				) : (
					value || (
						<Text fz={fz} fw={600} c="dark.8">
							{LONG_DASH}
						</Text>
					)
				)}
			</div>
		</InvestorDetailsRowStyles>
	);
};
